import { actions as spidActions } from '@spp/redux-spid';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';

const getRedirectUri = ({ protocol, host }) => `${protocol}//${host}/auth/callback`;
const isAppRegex = /-app$/;

export default async function initSpid({ thunkDispatch, getState }) {
    const {
        article: { customProperties: { vg_paywall: isSubscription } = {} } = {},
        device,
    } = getState();

    const cookieBeforeSpid = hasVarnishCookie();
    const spidConfig = config.spid;

    const isAppAndPaywalledArticle = isSubscription && isAppRegex.test(device);

    // clear spid hasSession cache if referer is payment.schibsted.no
    if (
        !cookieBeforeSpid &&
        (/payment\.schibsted\.no|\/auth\/callback/.test(document.referrer) ||
            isAppAndPaywalledArticle)
    ) {
        try {
            window.localStorage.removeItem('hasSession-cache');
        } catch (err) {} // eslint-disable-line
    }

    if (!spidConfig.redirectUri) {
        spidConfig.redirectUri = getRedirectUri(window.location);
    }
    await thunkDispatch(spidActions.start(spidConfig));
    const cookieAfterSpid = hasVarnishCookie();
    const spidCookieAppeared = !cookieBeforeSpid && cookieAfterSpid;

    // reload paid article after spid login
    if (isSubscription && spidCookieAppeared) {
        window.location.reload(true);
    }
}

function hasVarnishCookie() {
    return document.cookie.indexOf('SP_ID') > -1;
}



/** WEBPACK FOOTER **
 ** ./src/utils/init-spid.js
 **/